export default (value) => /^true$/i.test(value);
